import React, { useState } from 'react';
import { useTimer } from '../context/TimerContext';
import { Link } from "react-router-dom";

// Hsh utility
async function hashText(text) {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

// Pre-generated hash of your admin password
const ADMIN_HASH = "6c0b25da2a2a9c72a76707d893a50c351daf8aca41f9a7cc54e7e273ee07965e";

function AppAdmin() {

  const [password, setPassword] = useState('');
  const [authenticated, setAuthenticated] = useState(false);
  const [error, setError] = useState('');

  const { masterTime, updateMasterTime } = useTimer();

  const handleLogin = async (e) => {
    e.preventDefault();

    const hash = await hashText(password);

    if (hash === ADMIN_HASH) {
      setAuthenticated(true);
      setError('');
    } else {
      setError("Incorrect password");
    }
  };

  const handleLogout = () => {
    setAuthenticated(false);
    setPassword('');
  };

  const handleIncrease = () => {
    updateMasterTime(masterTime + 300);
  };

  const handleDecrease = () => {
    updateMasterTime(Math.max(masterTime - 300, 0));
  };

  const handleReset = () => {
    updateMasterTime(30 * 60);
  };

  if (!authenticated) {
    return (
      <div id="app-admin" className="page physical">

        {/* -- Background animation -- */}
        {/* <div id="anim-dots-1" className="anim-dots"></div>
        <div id="anim-dots-2" className="anim-dots"></div>
        <div id="anim-dots-3" className="anim-dots"></div>
        <div id="anim-dots-4" className="anim-dots"></div>
        <div id="anim-dots-5" className="anim-dots"></div>
        <div id="anim-dots-6" className="anim-dots"></div> */}
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12"></div>
            </div>
        </header>

        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="box-wrapper-admin" className="text-center">
                    <div className="admin-body">
                      <h1>Cyber Escape Room Admin</h1>
        <form onSubmit={handleLogin}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter admin password"
          />
          <button className="btn" type="submit">Login</button>
        </form>
        {error && <p style={{ color: 'red' }}>{error}</p>}
                      <p className="mt-2"><Link to=".." id="admin-home-link">&lt; Start Page</Link></p>
                      <p class="mt-4 text-small">CER Version 1.1</p>
                    </div>
                  </div>
                </div>
            </div>
        </main>

         <footer className="container-fluid">
            <div className="row">
                <div className="col-12"></div>
            </div>
        </footer>
      
      </div>

    );
  }

  return (

      <div id="app-admin" className="page physical">

        {/* -- Background animation -- */}
        {/* <div id="anim-dots-1" className="anim-dots"></div>
        <div id="anim-dots-2" className="anim-dots"></div>
        <div id="anim-dots-3" className="anim-dots"></div>
        <div id="anim-dots-4" className="anim-dots"></div>
        <div id="anim-dots-5" className="anim-dots"></div>
        <div id="anim-dots-6" className="anim-dots"></div> */}
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12"></div>
            </div>
        </header>

        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="box-wrapper-admin" className="text-center">
                    <div className="admin-body mt-auto">
                      <h1>Cyber Escape Room Admin</h1>
                      <h2>Timer Duration</h2>
                      <p>The standard duration is 30 minutes, but this can be changed.</p>
                      <p>Alter the time <strong>before</strong> starting a new game, then go to the Start page.</p>
                      <p><strong id="duration">Current duration: {Math.floor(masterTime / 60)} minutes</strong></p>
                      <p>
                        <button className="btn" onClick={handleIncrease}>Increase by 5 mins</button>
                        <button className="btn" onClick={handleDecrease}>Decrease by 5 mins</button>
                        <button className="btn"onClick={handleReset}>Reset to 30 mins</button>
                      </p>
                      <h2>Cache Video</h2>
                      <p className=""><Link to="/video-download" id="admin-home-link">Cache videos for offline use &gt;</Link></p>
                    </div>
                    <div className="admin-footer">
                        <button className="btn" onClick={handleLogout}>Logout</button>
                    </div>
                  </div>
                </div>
            </div>
        </main>

         <footer className="container-fluid">
            <div className="row">
                <div className="col-12"></div>
            </div>
        </footer>
      
      </div>
  );
}

export default AppAdmin;